import { Modal } from 'react-bootstrap'
import { BasicButton } from '../../widgets/components/UI/BasicButton'
import { useIntl } from 'react-intl'
import { ToolTipUI } from '../../widgets/components/UI/ToolTipUI'

export const HiddenOrTrash = ({
  setHiddenTrashModal,
  hiddenTrashModal,
  onMoving,
  hiddenTrashLoading,
  mainText,
  heading,
  btnText,
  showBool,
  is_hidden,
  is_trash
}: {
  setHiddenTrashModal: (value: any) => void
  hiddenTrashModal: any
  onMoving: any
  hiddenTrashLoading: boolean
  mainText: string
  heading: string
  btnText: string
  showBool: boolean
  is_hidden: any
  is_trash: any
}) => {
  const { formatMessage } = useIntl()
  return (
    <>
      <Modal
        show={hiddenTrashModal}
        onHide={() => setHiddenTrashModal(null)}
        aria-labelledby='contained-modal-title-vcenter'
        centered
      >
        <Modal.Header closeButton>
          <h2>{formatMessage({ id: heading })}</h2>
        </Modal.Header>
        <Modal.Body>
          <div className='d-flex justify-content-between'>
            <p className={showBool && is_hidden === 'all' ? 'text-dark' : (!showBool && is_trash === 'all' ? 'text-danger' : 'text-dark')}> {formatMessage({ id: mainText })}</p>
            <ToolTipUI
              tooltipText={formatMessage({ id: 'GLOBAL.TOOLTIP.CREATEFOLDER.FOLDERNAME' })}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          {/* <BasicButton
            height='44px'
            border='none'
            color='#F5F8FA'
            textColor='#7E8299'
            padding='12px 16px'
            onClick={() => {
                setHiddenTrashModal(null)
            }}
            buttonText='Cancel'
            minWidth={56}
          />

          <BasicButton
            height='44px'
            border='1px solid #4776E6'
            color='#4776E6'
            textColor='white'
            padding='12px 24px'
            onClick={() => {
                onMoving()
            }}
            buttonText={btnText}
            minWidth={56}
            loading={hiddenTrashLoading}
            disabled={hiddenTrashLoading}
          /> */}
          <div className='d-flex flex-md-row flex-column justify-content-md-end gap-2 w-100'>
            <BasicButton
              onClick={() => {
                setHiddenTrashModal(null)
              }}
              buttonText='Cancel'
              customClass='w-md-auto w-100 custom-button-property bg-light text-muted order-2 order-md-1'
            />

            <BasicButton
              onClick={() => {
                onMoving()
              }}
              buttonText={btnText}
              customClass='w-md-auto w-100 custom-button-property bg-primary text-white order-1 order-md-2'
              loading={hiddenTrashLoading}
              disabled={hiddenTrashLoading}
            />
          </div>
        </Modal.Footer>
      </Modal>
    </>
  )
}
